import React, { useEffect } from 'react';
import PlatesList from '@shared/components/PlatesList';
import { Grid } from '@mui/material';
import FlightsSearchForm from '@shared/pages/Flights/FlightsSearchForm';
import TabsHeader from '@shared/components/TabsHeader';

import ImageSlider from '@shared/components/ImageSlider';

import { useSelector } from 'react-redux';

const Flights = () => {
  const { business_types } = useSelector(store => store.pageConfiguration);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const typePlate = 0;

  return (
    <div style={{ overflow: 'hidden' }}>
      <TabsHeader site={typePlate} />
      <FlightsSearchForm />

      <Grid
        container
        justifyContent="center"
        alignItems="center"
        direction="column"
        className="minWebPadding"
        style={{ paddingBottom: '80px' }}
      >
        <ImageSlider />

        <PlatesList
          title={
            business_types.code == 'BTC' ? 'Principales Destinos' : 'Vuelos'
          }
          IdServiceType={1}
          section={'main-destinations'}
          typePlate={typePlate}
        />

        {business_types.code == 'BTC' && (
          <PlatesList
            title="Propuestas Irresistibles"
            IdServiceType={4}
            section={'irresistible-packages'}
            typePlate={2}
          />
        )}
      </Grid>
    </div>
  );
};

export default Flights;
